import React from 'react';
import PropTypes from 'prop-types';
import { compose, withProps } from 'recompose';
import { connect } from 'react-redux';

import MetaCheckbox from '../MetaCheckbox';

import s from './styles.less';

const propTypes = {
  planId: PropTypes.number.isRequired,
  fields: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      value: PropTypes.bool.isRequired,
    }).isRequired,
  ),
};
const defaultProps = {
  fields: [],
};

const MetaToggleDisplay = ({ fields, planId }) =>
  fields.length !== 0 ? (
    <div className={s.wrapper}>
      {fields.map(({ id, label, value }) => (
        <div key={id}>
          <MetaCheckbox name={id} planId={planId} checked={value} />
          <label className={s.label} htmlFor={id}>
            {label}
          </label>
        </div>
      ))}
    </div>
  ) : null;

MetaToggleDisplay.propTypes = propTypes;
MetaToggleDisplay.defaultProps = defaultProps;

const mapStateToProps = ({
  admin: {
    planDetails,
    planCancellationDetails: { isDirectDebitCancelled, isRefunded },
  },
}) => ({
  planId: planDetails.id,
  fields: [
    {
      id: 'isDirectDebitCancelled',
      label: 'Direct debit cancelled',
      value: isDirectDebitCancelled,
    },
    {
      id: 'isRefunded',
      label: 'Refunded',
      value: isRefunded,
    },
  ],
});

export default compose(
  connect(mapStateToProps),
  withProps(({ updateCancellationMeta }) => ({
    onUpdate: ({ target: { name, checked } }) =>
      updateCancellationMeta(name, checked),
  })),
)(MetaToggleDisplay);
